'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { getENV, OneTrustScripts, useCacheKey, useDeviceType, useOptimizely } from '@libs/common-next';

import { DigitalData } from '../DigitalData';
import { useCustomerKey } from './hooks';

export function TrackingScripts() {
    const { customerKey } = useCustomerKey();
    const { cookies, headers } = useCacheKey();
    const { init } = useOptimizely();
    const pathname = usePathname();
    const { deviceType } = useDeviceType();
    const team = cookies.get('x-petm-team');
    const isBot = headers.has('x-petm-bot');

    useEffect(() => {
        if (pathname) init({ pathname, deviceType, team, isBot });
    }, [init, pathname, deviceType]);

    const isOneTrustEnabled = getENV('NEXT_PUBLIC_ONETRUST_ENABLED');

    return (
        <>
            <DigitalData />
            {isOneTrustEnabled && <OneTrustScripts data-testid="onetrust-script" customerKey={customerKey} />}
        </>
    );
}
